import React from 'react'
import { Select, MenuItem, Typography, Paper } from '@material-ui/core'

import classes from './CustomedSelect.module.scss'

export default function CustomedSelect(props) {
  const { label = '', name, required, id, readOnly, constainerStyle = {}, error, onChange, type, ...other } = props
  const { value = '' } = props

  const [_error, setError] = React.useState()
  React.useEffect(() => {
    setError()
    if (typeof value === 'string') {
      if (!value.trim()) setError(error)
    }
    if (typeof value === 'number') {
      if (value <= 0) setError(error)
    }
  }, [error, value])

  const inputStyle = {
    fontSize: '14px',
  };

  const handleOnChange = e => {
    setError()
    if (typeof onChange === 'function') onChange(e)
  }

  return (
    <div className={classes.root} style={constainerStyle}>
      <Typography variant='subtitle2' className={classes.label}>
        {label}
        {!readOnly && required ? ' *' : ''}
      </Typography>
      <div className={classes.wrapper}>
        {readOnly ? (
          //  Read Only Value
          <Typography id={props.id} variant='subtitle2' className={`${classes['read-only-value']} ${classes['read-only-value']}`}>
            {props.value}
          </Typography>
        ) : (
          <React.Fragment>
            <Paper className={`${classes['text-field']} ${_error && classes['has-error']}`}>
              <Select
                id={id}
                value={value.releasingCenter}
                className={classes.input}
                style={inputStyle}
                name={name}
                onChange={handleOnChange}
                type={type}
                {...other}
              >
                {props.suggestions.map((item, index) => (
                  <MenuItem value={item}>{item}</MenuItem>
                ))}
              </Select>
            </Paper>
            {_error && <span className={classes.error}>{_error}</span>}
          </React.Fragment>
        )}
      </div>
    </div>
  )
}
